import React, { useRef } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Slider from 'react-slick';
import Col from 'react-bootstrap/Col';
import styles from '/styles/pstlandingpage.module.scss'
import CustomImage from "../CustomImage";
import { Button } from "react-bootstrap";
import useZipmeLink from "../../hooks/useZipmeLink";
import { isFrappeOrJotFormClass } from "../../utils/helpers";

interface Props {
  eventData: any;
}
const RecruitmentPartner: React.FC<Props> = (props) => {
  const { eventData } = props;
  const sliderRef = useRef<Slider>(null);
  const recruitmentPartnerData = eventData.recruitmentPartner;
  const buttonLabel = 'Enquire Now';

   const { zipmeLink, generateLink } = useZipmeLink();

  var settingsCountrySlider = {
    dotsClass: styles.sliderDots,
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  };
  return (
    <>
      <div className={styles.elanLoansComp} style={{ backgroundColor: recruitmentPartnerData?.sectionBgColor || "#fffff" }}>
        <Container>
          <Row>
            <Col md={12} >
              <div className={styles.elanContent} >
                {recruitmentPartnerData?.recruitmentPartnerTitle}
              </div>
            </Col>
            <Col md={12} >
              <div className={styles.elanSubheading} >
                {recruitmentPartnerData?.recruitmentPartnerSubTitle}
              </div>
            </Col>
          </Row>
          <Row>
            <div className={styles.imageDiv}>
              <Slider {...settingsCountrySlider} ref={sliderRef} className={styles.slider}
              >
                {
                  recruitmentPartnerData?.recruitmentPartners?.length > 0 &&
                  recruitmentPartnerData.recruitmentPartners.map((img: any, index: any) => {
                    return (<>
                      <div className={styles.logo} >
                        <div className={styles.imageDiv} key={index}>
                          <CustomImage
                            src={img?.image?.url} alt={img?.image?.alternativeText} width={180} height={120} className={styles.image}
                          />
                        </div>
                      </div>

                      <div>{img?.name}</div>
                    </>
                    )
                  })
                }
              </Slider>
              <div className={styles.button} >
               
                <Button 
                 id='enquirebtn'
                 variant='primary'
                 size='lg'
                onClick={() => {
                      generateLink(eventData?.externalLink)
                  }}
                      className={`${styles.btnReg}${eventData.meta?.jotforms[0]
                          ? ` ${isFrappeOrJotFormClass(eventData.meta?.jotforms[0].jotformid)}`
                          : ''
                          }`}
                  >
                     { recruitmentPartnerData.button?.label || buttonLabel }
                  </Button>
              </div>
            </div>
          </Row>
        </Container>
      </div>
    </>
  )
}
export default RecruitmentPartner;